import { SummaryManager } from 'utils/DataManager/summaryManager';
import { MasterAccountManager } from 'utils/DataManager/masterAccountManager';
import { FeatureFlagManager } from 'utils/featureFlagManager';
import { FeatureFlagHelper } from 'utils/featureFlagHelper';
import { AppState } from 'stores/appState';
import { FeatureFlags } from 'typings/enums';
import DiagnosticsManager from 'utils/DataManager/diagnosticsManager';
import UserDataManager from 'utils/DataManager/userDataManager';
import ConfigurationDataManager from 'utils/DataManager/configurationDataManager';

let summaryManager: SummaryManager;
let masterAccountManager: MasterAccountManager;
let featureFlagManager: FeatureFlagManager;
let featureFlagHelper: FeatureFlagHelper;
let diagnosticsManager: DiagnosticsManager;
let userDataManager: UserDataManager;
let configurationDataManager: ConfigurationDataManager;
let appState: AppState;

// initializes all of our singleton objects
const init = (featureFlagState?: {[key in FeatureFlags]: boolean|number}): void => {
    appState = new AppState();
    summaryManager = new SummaryManager({appState});
    diagnosticsManager =  new DiagnosticsManager({appState});
    masterAccountManager =  new MasterAccountManager({appState});
    userDataManager = new UserDataManager({appState});
    configurationDataManager = new ConfigurationDataManager({appState});
    featureFlagHelper = new FeatureFlagHelper(featureFlagState);
};

const initFeatureFlagManager = (userInfo: IUserInfo, featureFlagServiceKey: string): void => {
    featureFlagManager = new FeatureFlagManager({userInfo, featureFlagServiceKey});
};

export {
    init,
    initFeatureFlagManager,
    summaryManager,
    masterAccountManager,
    configurationDataManager,
    diagnosticsManager,
    appState,
    featureFlagHelper,
    userDataManager,
    featureFlagManager
};
